import React from 'react';
import Footer from './components/Footer';
import Header from './components/Header';
import './Help.css';

const AboutUs = () => {
  return (
    <div className="App">
      <Header />
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }} className='help-content'>
        <h1>About Us</h1>
        <div style={{ marginTop: '0px' }}>
          <h3>Why Did We Create Domogogo?</h3><br/>
          <p>
            After 15 years of living in London, experiencing 8 house moves, and viewing over 100 properties, we often found ourselves asking the same question: <strong>"How can we take the emotion out of our search and make an objective decision on where to live?"</strong>
          </p><br/>
          <p>
            As product managers, this felt oddly familiar. In our day-to-day work, we focus on answering critical questions: <em>What should we build next? What adds the most value for users? What makes the most sense for the business?</em> These same principles apply when searching for a home: <em>Which property has room to grow? Which one has the best garden? How long is the lease?</em>
          </p><br/>
          <p>
            This thought process inspired us to bring a product mindset to the home search experience. Imagine if you could score properties objectively, balancing all the factors that matter most to you, and confidently choose the best one. That idea became the foundation of Domogogo.
          </p><br/>
          <p>
            It all started with a simple spreadsheet—an early prototype that let us adjust the importance of features we valued and score properties accordingly. While the spreadsheet worked for us, it felt overwhelming for friends and family who wanted to try our "clever ranking system." So, with a touch of tech wizardry, Domogogo was born—a user-friendly platform designed to simplify and empower your property search.
          </p><br/>
          <h3>What’s Behind the Name?</h3><br/>
          <p>
            A former colleague once said, "If you want a cool startup name, use Google Translate with Esperanto as the target language." Inspired by that, we discovered <strong>"Domo"</strong> means "house" and <strong>"Rango"</strong> means "rank." We combined and simplified these to create <strong>Domogogo</strong>, representing our mission to help you rank and find your perfect home with ease.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;

